import { isFeatureEnabled } from '~/utils/isFeatureEnabled'

export type FeatureFlag = (
  'sff_vrach_cis'
)

export default defineNuxtPlugin(() => {
  const mainStore = useMainStore()

  return {
    provide: {
      featureFlag: (feature: FeatureFlag) => {
        return isFeatureEnabled(feature, mainStore.featureFlags)
      },
    },
  }
})
